import { createIntl, createIntlCache } from 'react-intl';

import AppLocale from 'lngProvider';

import { get } from '@src/packages/utils/storage';

export const translateString = (idIntl, values, defaultMessage) => {
  const storedLocale = get('locale');
  const localeKey = storedLocale?.locale ?? 'es';
  const currentAppLocale = AppLocale[localeKey];

  const cache = createIntlCache();
  const intl = createIntl(
    {
      locale: currentAppLocale.locale,
      messages: currentAppLocale.messages,
    },
    cache,
  );

  return intl.formatMessage(
    {
      id: idIntl,
      ...(defaultMessage != null ? { defaultMessage } : {}),
    },
    values,
  );
};
